(function () {
  'use strict';

  // ── Configuração ─────────────────────────────────────────────────────────
  const API_URL      = (window.COPI_CONFIG && window.COPI_CONFIG.apiUrl)
    ? window.COPI_CONFIG.apiUrl
    : 'https://copatex-chatbot-production.up.railway.app/api/chat';
  const WHATSAPP_URL = (window.COPI_CONFIG && window.COPI_CONFIG.whatsappUrl)
    ? window.COPI_CONFIG.whatsappUrl
    : 'https://wa.me/5511994045750';
  const SESSION_KEY = 'copi_history';
  const MAX_HISTORY = 20;

  // Atalhos rápidos — sem "Falar com atendente"
  const QUICK_REPLIES = [
    { label: '📦 Rastrear meu pedido',     text: 'Quero rastrear meu pedido' },
    { label: '🛍️ Ajuda com um produto',    text: 'Preciso de ajuda com um produto' },
    { label: '🔄 Trocas e devoluções',     text: 'Como funciona a troca e devolução?' },
    { label: '📍 Informações das lojas',   text: 'Quais são os endereços e horários das lojas?' },
    { label: '🏪 Atacado',                 text: 'Quero informações sobre atacado' },
  ];

  // Pedido explícito de atendente humano pelo cliente
  const EXPLICIT_HUMAN_RE = /\batendente\b|falar com (algu[eé]m|humano|atendente)|preciso de ajuda humana|quero falar com|n[aã]o (consegui|resolvi|entendi)|\bhumano\b/i;

  // Frases que indicam Copi sugerindo contato com equipe
  const COPI_SUGGESTION_RE = /vou (conectar|encaminhar|transferir)|equipe especializada|atendente especializada|entre em contato|entrar em contato|n[aã]o (tenho|consigo|posso) (acesso|informa|verificar|ajudar)/i;

  // Intents que recebem dica discreta ao final
  const HINT_INTENTS = new Set(['RASTREIO', 'TROCA_DEVOLUCAO']);
  const HINT_TEXT    = "Se precisar de mais ajuda, escreva 'atendente'.";

  // ── Elementos ────────────────────────────────────────────────────────────
  const toggleBtn  = document.getElementById('copi-toggle');
  const widgetEl   = document.getElementById('copi-widget');
  const closeBtn   = document.getElementById('copi-close');
  const messagesEl = document.getElementById('copi-messages');
  const inputEl    = document.getElementById('copi-input');
  const sendBtn    = document.getElementById('copi-send');
  const iconChat   = document.getElementById('copi-icon-chat');
  const iconClose  = document.getElementById('copi-icon-close');

  // ── Estado ───────────────────────────────────────────────────────────────
  let history              = loadHistory();
  let isOpen               = false;
  let isWaiting            = false;
  let messageCount         = Math.floor(history.length / 2);
  let humanSuggestionCount = 0; // vezes que a Copi sugeriu contato na sessão

  // ── Sessão ───────────────────────────────────────────────────────────────
  function loadHistory() {
    try { return JSON.parse(sessionStorage.getItem(SESSION_KEY) || '[]'); }
    catch { return []; }
  }
  function saveHistory() {
    try { sessionStorage.setItem(SESSION_KEY, JSON.stringify(history)); }
    catch { /* storage cheio */ }
  }

  // ── Abertura/fechamento ───────────────────────────────────────────────────
  toggleBtn.addEventListener('click', toggle);
  closeBtn.addEventListener('click', close);

  function toggle() { isOpen ? close() : open(); }

  function open() {
    isOpen = true;
    widgetEl.classList.remove('hidden');
    widgetEl.classList.add('opening');
    widgetEl.addEventListener('animationend', () => widgetEl.classList.remove('opening'), { once: true });
    iconChat.classList.add('hidden');
    iconClose.classList.remove('hidden');

    if (messagesEl.children.length === 0) {
      history.length === 0 ? showWelcome() : restoreMessages();
    }
    setTimeout(() => inputEl.focus(), 50);
  }

  function close() {
    isOpen = false;
    widgetEl.classList.add('hidden');
    iconChat.classList.remove('hidden');
    iconClose.classList.add('hidden');
  }

  // ── Boas-vindas ──────────────────────────────────────────────────────────
  function showWelcome() {
    appendBotMessage('Oi! Sou a Copi, assistente virtual da Copatex Enxovais! 😊 Como posso te ajudar hoje?');
    appendQuickReplies();
  }

  function restoreMessages() {
    for (const msg of history) {
      appendMessage(msg.role === 'user' ? 'user' : 'bot', msg.content, false);
    }
    scrollToBottom();
  }

  // ── Renderização ─────────────────────────────────────────────────────────
  function appendBotMessage(text, animate = true) {
    appendMessage('bot', text, animate);
  }

  function parseMarkdown(text) {
    return text
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
      .replace(/\*(.+?)\*/g, '<em>$1</em>')
      .replace(/\n/g, '<br>');
  }

  function appendMessage(role, text, animate = true) {
    const div = document.createElement('div');
    div.className = `copi-msg ${role}`;
    if (!animate) div.style.animation = 'none';
    div.innerHTML = parseMarkdown(text);
    messagesEl.appendChild(div);
    scrollToBottom();
    return div;
  }

  // Dica discreta após resposta de rastreio ou troca/devolução
  function appendHint(text) {
    const div = document.createElement('div');
    div.className = 'copi-msg-hint';
    div.textContent = text;
    messagesEl.appendChild(div);
    scrollToBottom();
  }

  // ── Atalhos rápidos ───────────────────────────────────────────────────────
  function appendQuickReplies() {
    const wrap = document.createElement('div');
    wrap.className = 'copi-quick-replies';
    wrap.id = 'copi-quick-replies';
    for (const opt of QUICK_REPLIES) {
      const btn = document.createElement('button');
      btn.className   = 'copi-quick-btn';
      btn.textContent = opt.label;
      btn.addEventListener('click', () => {
        removeQuickReplies();
        submitMessage(opt.text);
      });
      wrap.appendChild(btn);
    }
    messagesEl.appendChild(wrap);
    scrollToBottom();
  }

  function removeQuickReplies() {
    document.getElementById('copi-quick-replies')?.remove();
  }

  // ── Indicador de digitação ────────────────────────────────────────────────
  function showTyping() {
    const div = document.createElement('div');
    div.className = 'copi-typing';
    div.id = 'copi-typing';
    div.innerHTML = '<span></span><span></span><span></span>';
    messagesEl.appendChild(div);
    scrollToBottom();
  }
  function removeTyping() {
    document.getElementById('copi-typing')?.remove();
  }

  // ── Botão WhatsApp ────────────────────────────────────────────────────────
  function appendWhatsAppButton(url) {
    const wrap = document.createElement('div');
    wrap.className = 'copi-whatsapp-wrap';
    const a = document.createElement('a');
    a.href      = url;
    a.target    = '_blank';
    a.rel       = 'noopener noreferrer';
    a.className = 'copi-whatsapp-btn';
    a.innerHTML = `
      <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 .5C7.44.5.5 7.44.5 16c0 2.83.74 5.49 2.03 7.8L.5 31.5l7.93-2.07A15.45 15.45 0 0016 31.5C24.56 31.5 31.5 24.56 31.5 16S24.56.5 16 .5zm0 28.3a13.74 13.74 0 01-7-1.93l-.5-.3-5.18 1.36 1.38-5.04-.33-.52A13.8 13.8 0 1116 28.8zm7.58-10.3c-.41-.21-2.44-1.2-2.82-1.34-.38-.14-.65-.2-.93.21-.28.41-1.08 1.34-1.32 1.62-.24.28-.49.31-.9.1-.41-.2-1.73-.64-3.3-2.04-1.22-1.09-2.04-2.43-2.28-2.84-.24-.41-.03-.63.18-.84.18-.18.41-.48.62-.72.2-.24.27-.41.41-.69.14-.27.07-.52-.03-.72-.1-.2-.93-2.24-1.28-3.07-.33-.8-.67-.69-.93-.7h-.8c-.27 0-.72.1-1.1.52-.37.41-1.43 1.4-1.43 3.4s1.46 3.95 1.66 4.22c.2.28 2.87 4.38 6.96 6.14.97.42 1.73.67 2.32.86.97.31 1.86.27 2.56.16.78-.12 2.44-1 2.78-1.96.35-.97.35-1.8.25-1.97-.1-.17-.37-.27-.78-.48z"/>
      </svg>
      Falar com atendente no WhatsApp
    `;
    wrap.appendChild(a);
    messagesEl.appendChild(wrap);
    scrollToBottom();
  }

  // ── Scroll ────────────────────────────────────────────────────────────────
  function scrollToBottom() {
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  // ── Envio ─────────────────────────────────────────────────────────────────
  sendBtn.addEventListener('click', () => {
    const text = inputEl.value.trim();
    if (text) submitMessage(text);
  });

  inputEl.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      const text = inputEl.value.trim();
      if (text) submitMessage(text);
    }
  });

  async function submitMessage(text) {
    if (isWaiting) return;
    removeQuickReplies();

    // ── Pedido explícito de atendente: responde localmente sem chamar API ──
    if (EXPLICIT_HUMAN_RE.test(text)) {
      appendMessage('user', text);
      inputEl.value = '';
      appendBotMessage('Claro! Vou te conectar com nossa equipe agora. 😊');
      appendWhatsAppButton(buildWhatsAppUrl('Olá! Vim pelo chatbot da Copatex e gostaria de falar com um atendente.'));
      history.push({ role: 'user',      content: text });
      history.push({ role: 'assistant', content: 'Claro! Vou te conectar com nossa equipe agora. 😊' });
      saveHistory();
      messageCount++;
      return;
    }

    // ── Fluxo normal ─────────────────────────────────────────────────────
    appendMessage('user', text);
    inputEl.value    = '';
    isWaiting        = true;
    sendBtn.disabled = true;
    inputEl.disabled = true;
    showTyping();

    try {
      const res = await fetch(API_URL, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ message: text, history }),
      });
      removeTyping();

      if (res.status === 429) {
        appendBotMessage('Você enviou muitas mensagens em pouco tempo. Aguarde um instante. 😊');
        return;
      }
      if (!res.ok) {
        appendBotMessage('Ops, algo deu errado. Tente novamente em instantes.');
        return;
      }

      const data  = await res.json();
      const reply = data.message || 'Não consegui obter uma resposta.';
      const intent = data.intent || '';

      appendBotMessage(reply);

      // Dica discreta no final de respostas de rastreio e troca/devolução
      if (HINT_INTENTS.has(intent)) {
        appendHint(HINT_TEXT);
      }

      // Atualiza histórico
      history.push({ role: 'user',      content: text  });
      history.push({ role: 'assistant', content: reply });
      if (history.length > MAX_HISTORY) history = history.slice(-MAX_HISTORY);
      saveHistory();
      messageCount++;

      // Conta sugestões de contato da Copi
      if (COPI_SUGGESTION_RE.test(reply)) humanSuggestionCount++;

      // Mostra WhatsApp APENAS nas condições certas:
      // (a) servidor sinalizou transferência explícita
      if (data.transferToHuman) {
        const url = data.whatsappUrl || buildWhatsAppUrl('Olá! Vim pelo chatbot da Copatex e preciso de ajuda.');
        appendWhatsAppButton(url);
      }
      // (b) 4+ mensagens E Copi sugeriu contato 2+ vezes — cliente travado
      else if (messageCount >= 4 && humanSuggestionCount >= 2) {
        appendBotMessage('Parece que não consegui te ajudar completamente. Quer falar com nossa equipe? 😊');
        appendWhatsAppButton(buildWhatsAppUrl('Olá! Vim pelo chatbot da Copatex e não consegui resolver minha dúvida.'));
        humanSuggestionCount = 0; // reseta para não repetir
      }

    } catch {
      removeTyping();
      appendBotMessage('Erro de conexão. Verifique sua internet e tente novamente.');
    } finally {
      isWaiting        = false;
      sendBtn.disabled = false;
      inputEl.disabled = false;
      inputEl.focus();
    }
  }

  // ── Helpers WhatsApp ──────────────────────────────────────────────────────
  function buildWhatsAppUrl(text) {
    return `${WHATSAPP_URL}?text=${encodeURIComponent(text)}`;
  }

})();
